import { EndpointSetting } from "@/constants/app/type";
import { TourState } from "../types";
import { parseTourName } from "@/utils/tour/parseTourName";

export const callbackToursSearch: EndpointSetting['caller'] = (
  state: TourState,
  action: any,
  endpointName: any
) => {

  state.tours_search.loading = false
  state.tours_search.error = null
  state.tours_search.success = true
  state.tours_search.data = [
    ...(action.payload?.itemsProvider || []).map((tour: any) => {
      return {
        ...tour,
        tourName: parseTourName(tour.tourName)
      }
    })
  ]
  state.formSearch.departureDate = action.meta.arg.params.start_date
  state.tours_search.filter = {
    page: action.payload?.page || 1,
    pageSize: action.payload?.pageSize || 20,
    total: action.payload?.totalTour || 0,
  }
}